import { Menu } from '@headlessui/react'
import { NavLink, useLocation } from 'react-router-dom';

const DropdownLink = ({ children, className = "", showActive = false, ...props }) => {
  const location = useLocation();
  const isActive = showActive && (location.pathname + location.hash === props.to);
  
  return (
    <Menu.Item>{({ active }) => (
      <NavLink
        {...props}
        className={`w-full text-left block px-4 py-2 text-sm leading-5 ${isActive ? 'text-blue-700 dark:text-blue-300' : 'text-gray-700 dark:text-gray-200'} 
          ${active && !isActive ? 'bg-gradient-to-r from-gray-50 to-gray-100 dark:from-slate-800 dark:to-slate-700 text-blue-600 dark:text-blue-400' : ''} 
          ${isActive ? 'relative bg-gradient-to-r from-blue-50 to-transparent dark:from-slate-800 dark:to-transparent border-l-4 border-blue-500 dark:border-blue-400 font-medium pointer-events-none' : 'hover:text-blue-600 dark:hover:text-blue-400'} 
          focus:outline-none focus:ring-0 
          rounded-md my-0.5 
          transition-all duration-200 ease-in-out 
          relative overflow-hidden 
          ${className}`}
      >
        <span className={`relative z-10 flex items-center ${active ? 'transform translate-x-1' : ''} transition-transform duration-200`}>
          {active && (
            <span className="absolute left-0 w-1 h-full bg-blue-500 rounded-r-md mr-2" 
              style={{ marginLeft: '-1rem' }}></span>
          )}
          <span className="flex-1 pr-5">{children}</span>
          <span className="absolute right-1 w-4">
            {active && (
              <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
              </svg>
            )}
          </span>
        </span>
      </NavLink>
    )}
    </Menu.Item>
  );
}

export const DropdownButton = ({ children, className = "", ...props }) => (
  <Menu.Item>
    {({ active }) => (
      <button
        className={`w-full text-left block px-4 py-2 text-sm leading-5 text-gray-700 dark:text-gray-200 
        ${active ? 'bg-gradient-to-r from-gray-50 to-gray-100 dark:from-slate-800 dark:to-slate-700 text-blue-600 dark:text-blue-400' : ''} 
        hover:text-blue-600 dark:hover:text-blue-400 
        focus:outline-none focus:ring-0 
        rounded-md my-0.5 
        transition-all duration-200 ease-in-out 
        relative overflow-hidden 
        ${className}`}
        {...props}>
        {children}
      </button>
    )}
  </Menu.Item>
)

export default DropdownLink
